import ReactMarkdown from 'react-markdown/with-html';
import { ReactMarkdownProps } from 'react-markdown';
import breaks from 'remark-breaks';
import visit from 'unist-util-visit';
// eslint-disable-next-line import/no-unresolved
import { Node } from 'unist';

import renderers from './renderers';

const AD_KEY_REGEX = /\{ad type="(?<type>.+)"\}/;

export interface AstNode extends Node {
  value: string;
}

function ads(tree: any): any {
  visit<AstNode>(tree as any, 'text', (node, _, parent) => {
    // not sure why the type def doesn't have value, it appears to exist
    // in practicality
    const matches = (node.value as string).match(AD_KEY_REGEX);
    if (matches?.groups && parent) {
      // eslint-disable-next-line no-param-reassign
      parent.type = 'ad';
      // eslint-disable-next-line no-param-reassign
      (parent as any).value = matches.groups.type; // todo: parent is treated as a node with a .value, not sure why
    }
  });
  return tree;
}

export default function ContentfulMarkdown(props: ReactMarkdownProps): JSX.Element {
  return (
    <ReactMarkdown
      {...props}
      astPlugins={[ads]}
      plugins={[breaks]}
      escapeHtml={false}
      renderers={renderers}
    />
  );
}
